import React, { Component } from "react";
import Responsive from "../../components/Responsive";
import { checkTranslation, conditionalWidth, imageAddress, statusConvertor, translate } from "../../utils/useful";
import ConnectModals from "../../components/modals/ConnectModals";
import HttpServices from "../../utils/Http.services";
import ButtonAnimated from "../../components/buttons/ButtonAnimated";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Header from "../../components/header/Header";
import HubMainToolbar from "./HubMainToolbar";
import { nanoid } from "nanoid";
import StagesManager from "../../components/StagesManager";
import WidgetComponents from "../../components/widgets/WidgetComponents";
import FixedView from "../../components/FixedView";
import NotificationsMenu from "../../components/header/NotificationsMenu";

class HubMain extends Component {

    state = {
        notification: [
            { icon: '/assets/images/calln.svg', title: "{lang}}Connection", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/mailn.svg', title: "{lang}}Applets", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/videon.svg', title: "{lang}}Public Posts", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/messagen.svg', title: "{lang}}Expertise", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." }
        ],
        hasMoreUpdates: true,
        userId: '',
        colors: {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        },
        defaultHeaderConfig: {
            showToolbar: true, showSettings: false, title: this.props.hub?.fullname, image: this.props.hub?.image,
        },
        currentPage: { _id: 'default', mode: "page", name: "Default" },
        pages: [
            // { _id: nanoid(), mode: "page", name: "Page A" },
            // { _id: nanoid(), mode: "page", name: "Page B" },
            // { _id: nanoid(), mode: "page", name: "Page C" }
        ],
        driveInfo: [],
        filteredApplets: [],
    }

    componentDidMount() {
        // let filteredApplets = this.state.filteredApplets
        if (this.props.user?.info?._id) {
            this.setState({ userId: this.props.user?.info?._id, filteredApplets: this.props?.applets })
        }
        if (this.props.user?.info?.id) {
            this.setState({ userId: this.props.user?.info?.id, filteredApplets: this.props?.applets })
        }
        this.setHeader({
            'toolbar': this.toolbarView,
            'showToolbar': true,
            topHeaderComponent: this.topHeaderComponent,
        })

        setTimeout(() => {
            this.setState({ revealFixed: true }, () => {
                this.setHeader("dummy", 1)
            })
        }, 50);
    }

    toolbarView = () => {
        let colors = this.state.colors ?? {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }
        if (this.props.user.info?.colors) {
            colors = this.props.user.info.colors
        }
        return (
            <HubMainToolbar permissions={this.props.permissions} currentPage={this.state.currentPage} pages={this.props.pages} changePage={this.changePage} functionsHandler={this.toolbarFunctionsHandler} colors={colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.headers} view={this.state.currentView} />
        )
    }
    changePage = (prop) => {
        let currentPage = this.state.currentPage
        if (prop == 'default') {
            currentPage = { _id: 'default', mode: "dashboard", name: "Default" }
            this.stageManager.changeStage('Applets')
        }
        else {
            currentPage = prop
            this.stageManager.changeStage('Pages')
        }
        this.setState({ currentPage })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.state.defaultHeaderConfig) {
                    object = { ...this.state.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.state.showSettings) {
                    object.showSettings = this.state.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {

        let isOwner = this.props.hub?._id == this.props.user?.info?._id

        return (
            <div className='flexc'>


                <button onClick={() => this.plusFixedView.showView()} ref={el => this.plusBut = el} className="br-30  flexcc" >
                    <img src="/assets/icons/useful/more (1).png" className="rorate-90 invert" height={20} alt='' />
                </button>


                <div className="mx-1">
                    <NotificationsMenu language={this.props.language} hub={this.props.hub} width={this.props.width} colors={this.props.colors} applet={this.props.applet} features={this.props.features} page={this.props.page} addNewWindow={this.props.addNewWindow} />
                </div>



                {this.state.revealFixed && (
                    <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={7} maxWidth={200} >
                        <div className='bg-white br-10 py-2 px-2 shadow-3 sc-gray2 d-flex flex-column'>



                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.toggleNavigationMenu()}>
                                <img src='/assets/icons/useful/menu.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Share hub')}</p>
                            </button>

                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.toggleConfig()}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Block hub')}</p>

                            </button>

                        </div>
                    </FixedView>
                )}


                {(isOwner == false && this.props.relation && (this.props.relation?.status == 'I' || this.props.relation?.status == 'C' || this.props.relation?.status == 'S')) && (
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={() => this.connectAction()}
                        title={this.props.relation?.status == 'I' ? translate("Invited") : translate("Connected")}
                        icon='/assets/icons/arrow-right-white.svg'
                        textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                        invert={!this.props.colors?.iconInvert}
                        bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    />
                )}

                {(isOwner == false && (!this.props.relation || this.props.relation.status == 'P')) && (
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={() => this.connectAction()}
                        title={translate("Connect")}
                        icon='/assets/icons/arrow-right-white.svg'
                        textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                        invert={!this.props.colors?.iconInvert}
                        bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    />
                )}
            </div>
        )
    }

    goToApplet = (applet, connection) => {
        this.props.goToApplet(applet, connection)
    }

    connectAction = () => {
        // let data = { user: this.props.user._id }

        this.ConnectModals.open()
        // let data = { user: this.props.hub._id }
        // HttpServices.request('connectRequest', data, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         return
        //     }
        // })
    }

    filterApplets = (value) => {
        if (Array.isArray(this.props.applets)) {
            let filteredApplets = this.props.applets.filter((e) => e.applet.name.toLowerCase().substring(0, value.length) == value.toLowerCase())
            this.setState({ filteredApplets })
        }
    }

    checkName = (name, index, cb) => {
        if (!index) {
            index = 1
        }
        let driveInfo = this.state.driveInfo
        let found = false
        let driveName = index == 1 ? name : name + String(index - 1)
        for (let i = 0; i < driveInfo.length; i++) {
            if (driveInfo[i].name == driveName) {
                found = true
            }
        }
        if (found == true) {
            this.checkName(name, index + 1, cb)
        }
        else {
            if (index > 1) {
                name = name + String(index - 1)
            }
            cb(name)
        }

    }

    showPages = (item) => {
        // console.log('propgishhh', item)
        return (
            item.page && item.page.map((prop) => {
                return (
                    prop.children && prop.children.map((cprop) => {
                        return (
                            cprop.children && cprop.children.map((ccprop) => {
                                // console.log('itemmmmmmmmmmmmmmmmm', ccprop)
                                if (ccprop?.information) {

                                    let information = ccprop.information
                                    let Component = WidgetComponents[ccprop.type];
                                    if (Component) {
                                        return (
                                            <div className={"col-12 col-md-4 col-lg-4 mb-4"} key={ccprop._id ?? ccprop.id}>
                                                <div className="dashboard-widgets" style={{}}>
                                                    <Component data={ccprop} dashboard={this.state.info} />
                                                </div>
                                            </div>
                                        );
                                    } else { }
                                }
                                else {
                                    this.showModules(ccprop)
                                }
                            })
                        )


                    })
                )
            })
        )
    }

    render() {
        let colors = this.state.colors ?? {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }
        if (this.props.hub?.colors && Object.values(this.props.hub?.colors).length > 0) {
            colors = this.props.hub.colors
        }

        return (
            <div className="h-100 w-100 window-content-radius" >
                <div className="scroll-no-scrollbar h-100 w-100 d-flex flex-column window-content-radius" style={{ backgroundColor: "#f9f9f9" }}>
                    <div style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} username={this.props.hub?.username} hub={this.props.hub} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} />
                    </div>
                    {/* <div className="w-100" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                        <div className="w-100">
                            <div className="flexcb w-100 pt-1 pb-1 hub-bg">
                                <div className={"w-100 d-flex pld-2 flexc  " + (conditionalWidth(this.props.width, { xs: "", md: "" }))} style={{ zIndex: 1, position: 'sticky', left: 0 }}>
                                    <div className="prd-3 flexcc" style={{}}>
                                        <img className="" style={{ border: '3px solid #ffffff50', width: 50, height: 50, objectFit: 'cover', borderRadius: '50%', }} src={imageAddress(this.props.hub?.image, 'profile', 'small')} />
                                    </div>
                                    <div className="">
                                        <p className="font-size-16 weight-500" style={{ color: '#fff' }}>{this.props.hub?.fullname}</p>
                                        <p className="font-size-12" style={{ color: '#fff' }}>@{this.props.hub?.username}</p>
                                        {this.props.hub?.description && this.props.hub?.description != '' && (<p className="mt-1 text-smaller" style={{ color: '#fff' }}>{checkTranslation(this.props.hub?.description)}</p>)}
                                    </div>
                                </div>
                                <div className="px-2  flexcc">
                                    <div className={"w-100 " + (conditionalWidth(this.props.width, { xs: 'flexcc', sm: ' flexcc ', md: 'flexce' }))}>
                                        <div className="flexc">
                                            <div className="px-2">
                                                <ButtonAnimated
                                                    iconwidth='24px'
                                                    onClick={() => this.connectAction()}
                                                    title={this.props.hub._id == this.state.userId ? translate("Share") : translate("Connect")}
                                                    icon='/assets/icons/arrow-right-white.svg'
                                                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                                                    invert={!this.props.colors?.iconInvert}
                                                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-100 hub-bg2 flexc px-2" style={{}}>
                            <p className="mt-0 px-3 br-5 py-1 m-1  text-semibold text-small cursor-pointer text-semibold" style={{ backgroundColor: '#ffffff31', color: '#fff' }}>{translate('Applets')}</p>
                            <p className="mt-0 px-3 br-5 py-1 m-1 text-semibold text-small cursor-pointer" style={{ color: '#fff' }}>{translate('Home Page')}</p>
                        </div>
                    </div> */}

                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                        <div stage={0} stageName={'Applets'} className="w-100" style={{ backgroundColor: '#f9f9f9', }}>

                            <div className="w-100 d-flex flex-wrap">
                                <div className="w-100 flexcc pt-0" style={{ backgroundColor: '#eee', position: 'relative' }}>
                                    {/* <img className="" style={{ width: "100%", maxHeight: "250px", objectFit: "cover", position: 'relative' }} src="/images/hub/banner.jpg" /> */}
                                    {this.props.hub?.cover && (
                                        <img className="" style={{ width: "100%", objectFit: "cover", position: 'relative' }} src={imageAddress(this.props.hub?.cover)} />
                                    )}
                                    {/* <div className='applets-search mx-4 w-100 br-30 back-blur' style={{ padding: '8px 15px', top: '100px', position: 'absolute', maxWidth: 300 }} onClick={() => { this.addNewWindow('Search', { addNewWindow: this.addNewWindow }, "center"); }}>
                                        <div className='d-flex flexcb'>
                                            <input className="w-100 pt-1" type="text" placeholder={translate(`Search in applets ...`)} onChange={(e) => this.filterApplets(e.target.value)} style={{ backgroundColor: 'transparent', }} />
                                            <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="w-100 px-3 py-4">
                                <div className="d-flex px-1  w-100" style={{ borderTop: '0px solid #e0e4e8', position: '', bottom: 0, }}>
                                    <div className="d-flex flex-wrap  w-100" style={{}}>
                                        {this.state.filteredApplets?.length == 0 && (
                                            <div className="flexcc w-100 flex-column pt-5 text-center">
                                                <img className="mb-2" src="/assets/icons/useful/empty-folder.png" width={80} alt="" />
                                                <p className="text-small text-semibold" style={{ maxWidth: 250 }}>{translate("There are no applets available for you in this hub")}</p>
                                                <p className="text-smaller mt-2" style={{ maxWidth: 250 }}>{translate('You can Connect to the hub for new access. Use the "Connect" botton to proceed')}</p>

                                            </div>
                                        )}
                                        {Array.isArray(this.state.filteredApplets) && this.state.filteredApplets.map((prop, index) => {
                                            if (prop.applet) {
                                                // console.log(prop.applet)
                                                return (
                                                    <Responsive width={this.props.width} display={'flex'} media={{ xs: '6', sm: '3', lg: '2' }} key={prop._id}>
                                                        <div className="px-2 w-100 mb-2 flex-1 d-flex">
                                                            <div className="  w-100 mrd-2 px-2 py-2 mb-2 br-10 flex-1 hub-main " style={{}}>
                                                                <div className="w-100 ">
                                                                    <button onClick={() => this.goToApplet(prop.applet, prop)} className="w-100">
                                                                        <div className=" " style={{ padding: '8px 10px' }} key={prop.applet?._id}>
                                                                            <div className="position-relative d-flex mb-2">
                                                                                <img className="mt-1" src={prop.applet?.image ? imageAddress(prop.applet?.image) : ('/assets/icons/applets/' + ((prop.applet?.features && prop.applet?.features[0]) ? String(prop.applet?.features[0]).toLowerCase() : String(prop.applet?.type).toLowerCase()) + ".png")} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                                                                {prop.applet?.image && (
                                                                                    <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { backgroundColor: '#fff', bottom: 0, left: 65, width: 22, height: 22, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: 65, width: 22, height: 22, border: '1px solid #eee' }}>
                                                                                        <img className="" src={prop.applet?.image ? ('/assets/icons/applets/' + ((prop.applet?.features && prop.applet?.features[0]) ? String(prop.applet?.features[0]).toLowerCase() : String(prop.applet?.type).toLowerCase()) + ".png") : ('/assets/icons/portals/' + ((prop.applet?.features && prop.applet?.features[0]) ? prop.applet?.features[0] : prop.applet?.type) + ".svg")} style={{ width: 20, height: 20, borderRadius: '50%', border: '0px solid #eee' }} />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <div className="flex-column text-start ">
                                                                                <div className="">
                                                                                    <p className="mb-0   text-semibold " style={{ color: '#101010', fontSize: 15 }}>{checkTranslation(prop.applet?.name)}</p>
                                                                                    {/* <p className="mb-0 text-smaller text-semibold " style={{ whiteSpace: 'nowrap' }}>{this.props.language == 'fa' ? (translate('Applet') + ' ' + (prop.applet?.type ? translate(prop.applet?.type) : '')) : ((prop.applet?.type ? translate(prop.applet?.type) : '') + ' ' + translate('Applet'))}</p> */}
                                                                                </div>
                                                                                <div>
                                                                                    <p className="m-0 text-small text-semibold  mt-0" style={{ fontSize: 11, color: statusConvertor(prop?.status)?.color }}>{checkTranslation(statusConvertor(prop?.status)?.label)}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {this.props.inbox?.object[prop.applet?._id]?.count > 0 && (
                                                                            <div className="br-30 flexcc" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: 6, right: 6 }}>
                                                                                <p className="white font-size-12 text-semibold">{this.props.inbox.object[prop.applet._id]?.count}</p>
                                                                            </div>
                                                                        )}

                                                                        {prop.applet?.type == 'Settings' && this.props.inbox?.categorizer?.settings?.count > 0 && (
                                                                            <div className="br-30 flexcc" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: 6, right: 6 }}>
                                                                                <p className="white font-size-12 text-semibold">{this.props.inbox?.categorizer?.settings?.count}</p>
                                                                            </div>
                                                                        )}


                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Responsive>
                                                )
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div stage={1} stageName={'Pages'}>
                            <div className="row m-0 p-3 w-100" style={{ backgroundColor: '#f9f9f9' }}>
                                {this.state.currentPage &&
                                    // console.log('currentPagecurrentPage', this.state.currentPage)
                                    this.showPages(this.state.currentPage)
                                }
                            </div>
                        </div>
                    </StagesManager>
                    {/* <div>
                        <div>
                            {this.state.notification.map((item, index) => {
                                return (
                                    <div className="d-flex flexc px-5 ">
                                        <div className="d-flex flexc connect-selection px-3 br-10">
                                            <div className="">
                                                <div style={{ borderRight: "1px dashed #C3C3C3", width: "1px", height: "30px", margin: "auto", marginTop: '2px' }}></div>
                                                <div className="flexcc">
                                                    <img className="br-50" style={{ objectFit: "cover", width: "40px", height: "40px", }} src={item.icon} />
                                                </div>
                                                <div style={{ borderRight: "1px dashed #C3C3C3", width: "1px", height: "30px", margin: "auto" }}></div>
                                            </div>
                                            <div className="mld-4">
                                                <div className="d-flex flex-column">
                                                    <div className="flexc">
                                                        <p className="font-size-14 weight-900">{item.title}</p>
                                                    </div>
                                                    <div className="flexc">
                                                        <p className="font-size-12">{item.description}</p>
                                                    </div>
                                                    <div className="flexc">
                                                        <p className="font-size-12">{item.Date}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div> */}
                </div>
                <ConnectModals ref={el => this.ConnectModals = el} width={this.props.width} language={this.props.language} hub={this.props.hub} relation={this.props.relation} connectionTypes={this.props.connectionTypes} variables={this.props.variables} setRelation={this.props.setRelation} />
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HubMain);